import { render } from "./CookbookPopup.vue?vue&type=template&id=23c88bc4"
import script from "./CookbookPopup.vue?vue&type=script&lang=js"
export * from "./CookbookPopup.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__